import type React from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'

type TooltipProps = {
  id: string
  children: React.ReactNode
  place?: 'top' | 'bottom' | 'left' | 'right'
  trigger?: 'hover' | 'click'
  className?: string
}

export const Tooltip = ({ id, children, place = 'bottom', trigger = 'hover', className }: TooltipProps) => {
  return (
    <ReactTooltip
      id={id}
      place={place}
      data-tooltip-trigger={trigger}
      className={className}
    >
      {children}
    </ReactTooltip>
  )
}
